import { Platform, Linking } from 'react-native';
import { knownLinks } from 'utils/links';
export async function openMarketplace() {
    if (Platform.OS === 'android') {
        try {
            await Linking.openURL('market://details?id=com.emmaprod');
        }
        catch {
            await Linking.openURL(knownLinks.playStore);
        }
        return;
    }
    if (Platform.OS === 'ios') {
        await Linking.openURL(knownLinks.appStore);
    }
}
export async function openMarketplaceReview() {
    if (Platform.OS === 'android') {
        await openMarketplace();
        return;
    }
    if (Platform.OS === 'ios') {
        await Linking.openURL(`${knownLinks.appStore}?action=write-review`);
    }
}
